<template>
  <IconLucideInfo />
</template>
